# frozen_string_literal: true

module Engine
  module Game
    module G1873
    end
  end
end
